import { Text } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniText = withUnistyles(Text)

export default UniText
